/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Gallery_PhotosInputs */

const cs_draft_gallery_photos = /** @type {(inputs: Draft_Gallery_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotky inzerátu`)
};

const en_draft_gallery_photos = /** @type {(inputs: Draft_Gallery_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing photos`)
};

/**
* | output |
* | --- |
* | "Listing photos" |
*
* @param {Draft_Gallery_PhotosInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_gallery_photos = /** @type {((inputs?: Draft_Gallery_PhotosInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Gallery_PhotosInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_gallery_photos(inputs)
	return cs_draft_gallery_photos(inputs)
});